/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgScooter48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M22 34.938c-2.511.108-4.895-.035-7-.732V37.5h7v-2.562zm4 0c2.511.108 4.895-.035 7-.732V37.5h-7v-2.562zm-2-23.037c-1.788.032-3.282-.803-4.517-2.399v2.999c.75 2.393 2.637 2.895 4.517 2.999 1.88-.104 3.767-.606 4.517-2.999V9.503c-1.235 1.595-2.729 2.43-4.517 2.399z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M27 33.5V42a3 3 0 11-6 0v-8.5c.448-1.276 1.424-1.97 3-2 1.576.03 2.552.724 3 2z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M19.215 11.5h-.001a4.715 4.715 0 00-4.714 4.714V38h6M10 5.294h4.515c.638 0 1.258.215 1.759.61l3.468 2.729M14 38H9.5'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M14.5 29.5A4.5 4.5 0 0019 25V11.5M28.785 11.5h.001a4.715 4.715 0 014.714 4.714V38h-6'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24 6.5c-3 0-5 2.094-5 4.672 0 2.579 2.24 4.672 5 4.672s5-2.093 5-4.672C29 8.593 27 6.5 24 6.5v0zM21 29.604c0-.732.29-1.434.808-1.951C22.481 26.98 23.27 27 24 27c.73 0 1.519-.02 2.192.652.517.518.808 1.22.808 1.951V33.5c-.448-1.276-1.424-1.97-3-2-1.576.03-2.552.724-3 2v-3.896z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M38 5.294h-4.515c-.638 0-1.258.215-1.76.61l-3.468 2.729M34 38h4.5M33.5 29.5A4.5 4.5 0 0129 25V11.5'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M4 5.473C4 4.66 4.66 4 5.473 4H8.5a1.5 1.5 0 110 3H5.473C4.66 7 4 6.34 4 5.527v-.054zm40 0C44 4.66 43.34 4 42.528 4H39.5a1.5 1.5 0 100 3h3.028C43.34 7 44 6.34 44 5.527v-.054z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24 17v9'
      />
    </svg>
  );
}

export default SvgScooter48;
